import styles from './Skeleton.module.css'

export function Skeleton({
  height = '1rem',
  width = '100%',
}: {
  height?: string
  width?: string
}) {
  return (
    <span
      className={styles.skeleton}
      style={{ height, width }}
      aria-hidden="true"
    />
  )
}
